
import ContactForm from '../components/ContactForm'
// import Sponsors from '../components/Sponsors'
import IntSlides from '../components/IntSlides'
// import BreadCrumbs from '../components/BreadCrumbs'
export default {
  auth: false,
  components: {
    // BreadCrumbs,
    // Sponsors,
    ContactForm,
    IntSlides
  },
  data () {
    return {
      lang: 'es',
      cont: {
        en: {
          tit1: 'About Us',
          par1: 'Electrónica Poderosa Inc. is a company dedicated to the wholesale of artificial grass (also known as artificial turf, synthetic grass, or synthetic turf), artificial Ivy, artificial mulch, artificial plants, and all you need to complete all your installation projects. Our mission consists of offering a great variety of artificial turf and materials required for your projects. At Electrónica Poderosa, we stand out for providing our customers with the best service and best products in the market.',
          tit2: 'Our Products',
          par2: 'We have the best quality products with a warranty of up to 15 years. It also looks better than its organic equivalent, always maintaining its vivid color with very low maintenance cost and maximum performance. Artificial grass is environmentally friendly since it does not consume energy or water and it doesn’t need chemical products that can be harmful, which allows reducing the contamination and the harm against the environment.',
          tit3: 'It doesn’t matter how big or small your project is',
          par3: 'We have all the stock and a great variety to guarantee that you get all materials needed to make your artificial grass, Ivy wall or mulch project happen fast, with the best quality and efficiency. ',
          tit4: '¡We are breaking boundaries!',
          par4: 'We offer delivery and cover projects all over South-Florida. If your project requires a special delivery you can contact us. We deliver nationwide, The Caribbean, and Latin America. Our goal is to make Electrónica Poderosa a leading company of artificial grass, and to be one of the main distributors all over the state of Florida, creating along the way innovative projects that satisfy all our client`s needs.'
        },
        es: {
          tit1: 'Acerca de Nosotros',
          par1: 'Electrónica poderosa somos una empresa dedicada a la venta al mayor y detal de productos eléctricos, servicio de comercialización, producción, elaboración, exportación y fabricación de todo tipo de productos electrónicos. Nuestra misión consiste en ser la empresa líder en el mercado de artículos para iluminación y material eléctrico diseñando equipos de iluminación de gran calidad para conseguir la máxima eficiencia energética  para nuestros clientes, ser la empresa con mayor conocimiento en el mercado con una fuerza de ventas profesional y especializada.',
          tit2: 'Nuestros Productos',
          par2: 'Ofrecemos productos de la mejor calidad de iluminación, circuito cerrado, ferreteria, cableado, eléctricos y ahorradores de electricidad que abarcan las necesidades de nuestros clientes con un bajo costo máximo rendimiento.',
          tit3: 'No importa que tan pequeño o grande sea su proyecto',
          par3: 'Tenemos en el stock gran variedad de productos eléctricos y decorativos para garantizarle que todos los materiales necesarios para su proyecto en el hogar, comercio o fábrica, estén listos a tiempo con la mejor calidad, eficiencia y rapidez, ofreciéndole productos de gran tecnología.',
          tit4: '¡Queremos llegar más allá!',
          par4: 'Ofrecemos envíos y proyectos en toda Venezuela, pero si tu proyecto requiere de un envió especial nacional o internacional puedes comunicarte con nuestros asesores a través de nuestras redes sociales, Intagram: @electronicapoderosa, Facebook: @electronicapoderosa, Correo: electronicapoderosa88@gmail.com o a través nuestro números de contactos. Nuestro principal objetivo es lograr que Electrónica Poderosa sea la empresa líder en ventas de iluminación y uno de los principales distribuidores en Caracas Dtto. Capital generando así proyectos innovadores que satisfagan las necesidades de nuestros clientes.'
        }
      },
      topSlides: [
        {
          title: '',
          img: 'slider2.jpg'
        },
        {
          title: '',
          img: 'slider.jpg'
        }
      ],
      rightSlides: [
        {
          img: 'b3.jpg'
        },
        {
          img: 'b4.jpg'
        }
      ],
      leftSlides: [
        {
          img: 'b5.jpg'
        },
        {
          img: 'b6.jpg'
        }
      ]
    }
  },
  head: {
    title: 'Acerca de Nosotros - Electrónica Poderosa',
    meta: [
      { hid: 'description', name: 'description', content: 'Electrónica Poderosa Acerca de Nosotros' }
    ]
  }
}
